import { render, staticRenderFns } from "./ComFour.vue?vue&type=template&id=b7385db8&scoped=true&"
import script from "./ComFour.vue?vue&type=script&lang=js&"
export * from "./ComFour.vue?vue&type=script&lang=js&"
import style0 from "./ComFour.vue?vue&type=style&index=0&id=b7385db8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7385db8",
  null
  
)

export default component.exports